<!--
  功能：功能描述
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="zline-info">
    <div class="zline-title">
      <div class="zline-title-left">
        <!-- <span class="zline-title-left-text">T0超额收益分析</span> -->
        <span class="zline-title-left-text">使用该策略T0年化收益最高的3只股票：</span>
        <!-- <van-icon name="question-o" color="#4e5969" size="14px" @click="showLineTip()"> </van-icon> -->
      </div>
      <!-- <div class="zline-title-right">统计上线以来数据</div> -->
    </div>
    <!-- 内容部分 -->
    <!-- <div class="zline-content">
      <div class="zline-content-item">
        <div class="title-item-text">今日收益率</div>
        <div
          :class="[
            judgeColor(todayProfit),
            Math.abs(todayProfit) > 999 ? 'title-item-zf20' : 'title-item-zf'
          ]"
        >
          {{ toFixedNum(todayProfit, 2, '%',true) }}
        </div>
      </div>
      <div class="zline-content-item">
        <div class="title-item-text">累计收益率</div>
        <div
          :class="[
            judgeColor(dailyRateLast),
            Math.abs(dailyRateLast) > 999 ? 'title-item-zf20' : 'title-item-zf'
          ]"
        >
          {{ toFixedNum(dailyRateLast, 2, '%',true) }}
        </div>
      </div>
      <div class="zline-content-item">
        <div class="title-item-text">年化收益率</div>
        <div
          :class="[
            judgeColor(yearRate),
            Math.abs(yearRate) > 999 ? 'title-item-zf20' : 'title-item-zf'
          ]"
        >
          {{ toFixedNum(yearRate, 2, '%',true) }}
        </div>
      </div>
      <div class="zline-content-item">
        <div class="title-item-text">最大回撤</div>
        <div
          :class="[
            Math.abs(maxRetreatRate) > 999 ? 'title-item-zf20' : 'title-item-zf'
          ]"
        >
          {{ toFixedNum(maxRetreatRate, 2, '%') }}
        </div>
      </div>
    </div> -->
    <!-- 折线图部分 -->
    <!-- <div v-if="(dailyRateList && dailyRateList.length) || (policyRateList && policyRateList.length)">
      <div class="zline-chart" ref="chart2"></div>
    </div> -->

    <!-- 标题 -->
     <!-- <div class="zline-table-title" >使用该策略T0年化收益最高的3只股票：</div> -->
     <!-- 表格 -->
      <div class="zline-table">
        <van-row class="zline-table-header" >
          <van-col span="6">
            <span>名称/代码</span>
          </van-col>
          <van-col span="6">
            <span>今日收益</span>
          </van-col>
          <van-col span="6">
            <span>累计T0收益</span>
          </van-col>
          <van-col span="6">
            <span>年化收益率</span>
          </van-col>
        </van-row>
        <!-- 表格内容 -->
         <div v-if="top3List && top3List.length>0" >
          <van-row class="zline-table-content" v-for="(item, index) in top3List" :key="index">
          <van-col span="6"  @click="gotoStock(item.stockCode)" >
            <span class="zline-table-content-name" >{{ item.stockName }}</span>
            <span class="zline-table-content-code" >{{ cleanStockCode(item.stockCode) }}</span>
          </van-col>
          <van-col span="6">
            <span class="zline-table-content-rate" :class="[judgeColor(item.rate)]"  >{{ toFixedNum(item.rate, 2, '%',true) }}</span>
          </van-col>
          <van-col span="6">
            <span class="zline-table-content-rate" :class="[judgeColor(item.totalRate)]"  >{{ toFixedNum(item.totalRate, 2, '%',true) }}</span>
          </van-col>
          <van-col span="6">
            <span class="zline-table-content-rate" :class="[judgeColor(item.yearRate)]"  >{{ toFixedNum(item.yearRate, 2, '%',true) }}</span>
          </van-col>
        </van-row>
         </div>
         <div v-else>
          <van-row class="zline-table-content" >
            <van-col span="24">
              <span class="zline-table-content-name" style="display: block;text-align: center;width: 100%;margin: 10px auto;" >暂无数据</span>
            </van-col>
          </van-row>
         </div>

      </div>
  </div>
</template>

<script>
import { judgeColor, toFixedNum, formatDateToStr,cleanStockCode } from '@/utils/format';
export default {
  // 组件名称
  name: 'hedgingZline',
  // 组件参数 接收来自父组件的数据
  props: [
    'todayProfit', // 今日收益
    'totalRate', // 累计收益
    'yearRate', //年化收益率
    'maxRetreatRate', //最大回撤
    'dailyRateList', // 日收益率
    'policyRateList', // 策略收益率
    'activeInfo', //
    'dateList', // 日期列表
    'top3List', // 股票数据
    'dailyRateLast', // 累计收益
  ],
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      themeStyleVs: this.$route.query.themeStyleVs || 1,
      linXShaft: [],
      linYShaft: [],
      linYShaft2: []
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    // dailyRateList: {
    //   handler() {
    //     this.refreshChartData2();
    //   },
    //   deep: true,
    //   immediate: true
    // },
    // policyRateList: {
    //   handler() {
    //     this.refreshChartData();
    //   },
    //   deep: true,
    //   immediate: true
    // },
    dateList: {
      handler(newVal) {
        this.linXShaft = newVal.map((item) => formatDateToStr(item, '-'));
        this.$nextTick(() => {
          this.chartZxgInit();
        });
      },
      deep: true,
      immediate: true
    }
  },
  // 组件方法
  methods: {
    judgeColor,
    toFixedNum,
    formatDateToStr,
    cleanStockCode,
    // refreshChartData: function () {
    //   var usePolicy = Array.isArray(this.policyRateList) && this.policyRateList.length > 0;
    //   var source = usePolicy ? this.policyRateList : [];
    //   this.linYShaft = source.map(function (item) {
    //     return toFixedNum(item, 2, '');
    //   });
    //   this.$nextTick(() => {
    //     this.chartZxgInit();
    //   });
    // },
    // refreshChartData2: function () {
    //   var usePolicy2 = Array.isArray(this.dailyRateList) && this.dailyRateList.length > 0;
    //   var source2 = usePolicy2 ? this.dailyRateList : [];
    //   this.linYShaft2 = source2.map(function (item) {
    //     return toFixedNum(item, 2, '');
    //   });
    //   this.$nextTick(() => {
    //     this.chartZxgInit();
    //   });
    // },
    // zxg折线图数据
    chartZxgInit: function () {
      var _self = this;
      var usePolicy = Array.isArray(this.policyRateList) && this.policyRateList.length > 0;
      var source = usePolicy ? this.policyRateList : [];
      var usePolicy2 = Array.isArray(this.dailyRateList) && this.dailyRateList.length > 0;
      var source2 = usePolicy2 ? this.dailyRateList : [];
      this.linYShaft = source.map(function (item) {
        return toFixedNum(item, 2, '');
      });
      this.linYShaft2 = source2.map(function (item) {
        return toFixedNum(item, 2, '');
      });

      // 检查 DOM 元素是否存在
      if (!_self.$refs.chart2) {
        console.warn('Chart DOM element not found');
        return;
      }

      var chart = _self.$echarts.init(_self.$refs.chart2);
      var option = {
        grid: [
          {
            top: 20,
            bottom: 20,
            left: 40,
            right: 2
          }
        ],
        // color: ['#f79828','#286df7'],
        color: ['#286df7'],
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            // console.log(params);
            var result = params[0].name + '<br/>';
            params.forEach(function (item) {
              result += item.marker + item.seriesName + '：' + item.value + '%' + '<br>';
            });
            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: _self.themeStyleVs == 1 ? '#E8E8E8' : 'rgba(255, 255, 255, 0.1)'
            }
          },
          axisLabel: {
            margin: 6,
            color: '#6b7687',
            showMinLabel: true,
            showMaxLabel: true,
            interval: Math.max(0, (_self.linXShaft || []).length - 2),
            formatter: function (value, index) {
              //文本格式化
              if (index === 0) {
                return '{right|' + value + '}';
              } else if (index === (_self.linXShaft || []).length - 1) {
                return '{left|' + value + '}';
              } else {
                return '{left|' + value + '}';
              }
            },
            rich: {
              right: {
                width: 140,
                fontSize: 12,
                align: 'right'
              },
              left: {
                width: 144,
                fontSize: 12,
                align: 'left'
              }
            }
          },
          axisTick: {
            show: false
          },
          data: _self.linXShaft
        },
        yAxis: {
          type: 'value',
          scale: true,
          splitLine: {
            lineStyle: {
              color: _self.themeStyleVs == 1 ? '#E8E8E8' : 'rgba(255, 255, 255, 0.1)'
            }
          },
          axisLabel: {
            color: '#6b7687',
            margin: 2,
            formatter: '{value}%'
          }
        },
        series: [
          // {
          //   name: '全市场T0累计收益',
          //   data: _self.linYShaft,
          //   type: 'line',
          //   smooth: true,
          //   itemStyle: {
          //     opacity: 0
          //   },
          //   areaStyle: {
          //     color: {
          //       type: 'linear',
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: 'rgba(247, 152, 40, 0.2)' // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: 'rgba(40, 68, 247, 0)' // 100% 处的颜色
          //         }
          //       ],
          //       global: false // 缺省为 false
          //     }
          //   }
          // },
          {
            name: '我的T0累计收益',
            data: _self.linYShaft2,
            type: 'line',
            smooth: true,
            itemStyle: {
              opacity: 0
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(40, 109, 247, 0.2)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(40, 68, 247, 0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      };

      chart.setOption(option);
    },
    // 点击显示弹窗
    showLineTip: function () {
      var _this = this;
      _this.$dialog.alert({
        message: _this.activeInfo == 1 ?'取持仓股T0收益排名前50的股票':'取自选股T0收益排名前10的股票',
        confirmButtonText:'我知道了',
        confirmButtonColor:'#3b85fe'
      }).then(() => {
        // on close
      });
    },
    // 跳转到股票分时
    gotoStock: function (stockCode) {
      window.location.href = `dzh_browser_url&goto=0&type=2970&code=${stockCode}&kind=1&source=1&direct=1`;
    },
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 在实例初始化之后，组件属性计算之前，如data属性等
   */
  beforeCreate() {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * 在挂载开始之前被调用：相关的 render 函数首次被调用。
   */
  beforeMount() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() { },
  /**
   * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
   * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
   */
  beforeUpdate() {},
  /**
   * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
   * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
   */
  updated() {},
  /**
   * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
   */
  activated() {},
  /**
   * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
   */
  deactivated() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {},
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->
<style scoped lang="less">
.zline-info {
  .zline-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    .zline-title-left {
      &::before {
        content: '';
        display: inline-block;
        // vertical-align: middle;
        width: 3px;
        height: 10px;
        background-color: #3b85fe;
        border-radius: 88px;
        margin-right: 4px;
      }
      .zline-title-left-text {
        font-weight: 600;
        color: #1d2129;
        font-size: 16px;
        margin-right: 4px;
      }
    }
    .zline-title-right {
      color: #949da8;
      font-size: 12px;
    }
  }
  .zline-content {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: flex-start;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
    .zline-content-item {
      width: 100%;
      background: #f7f8fa;
      border-radius: 6px;
      padding: 12px 0;
      text-align: center;
      .title-item-text {
        color: #4e5969;
        font-size: 12px;
      }
      .title-item-zf {
        font-weight:500;
        font-size: 16px;
      }
      // .title-item-zf {
      //   font-weight: 500;
      //   font-size: 22px;
      // }
      // .title-item-zf20 {
      //   font-weight: 500;
      //   font-size: 20px;
      // }
    }
  }
  .zline-chart {
    height: 220px;
    margin-top: 12px;
  }
}

.zline-table-title {
  color:#1d2129;
  font-size:14px;
  margin: 10px 0;
  font-weight:500;
}

.zline-table {
  margin-top: 10px;
  .zline-table-header {
    text-align: right;
    color:#999999;
    font-size:12px;
    // 第一个元素
    .van-col:first-child {
      text-align: left;
    }
  }
  .zline-table-content {
     text-align: right;
     display: flex;
     align-items: center;
     margin-top: 12px;
     .van-col:first-child {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: flex-start;
      align-items: flex-start;
     }
     .zline-table-content-name {
      font-size:14px;
      color:#373a4d;
      font-weight:500;
     }
     .zline-table-content-code {
      font-size:12px;
      color:#999999;
     }
     .zline-table-content-rate {
      font-size:15px;
      font-weight:500;
     }
  }
}


.black_theme {
  .zline-info {
    .zline-title {
      .zline-title-left {
        .zline-title-left-text {
          color: #e4e9fe;
        }
      }
      .zline-title-right {
        color: #6b7687;
      }
    }
    .zline-content {
      .zline-content-item {
        background: #1d202d;
        .title-item-text {
          color: #aab9d1;
        }
        .title-item-zf {
          color: #e4e9fe;
        }
      }
    }
  }


.zline-table-title {
  color:#e4e9fe;
}

.zline-table {
  .zline-table-header {
    color:#6b7687;
  }
  .zline-table-content {
     .zline-table-content-name {
      color:#e4e9fe;
     }
     .zline-table-content-code {
      color:#6b7687;
     }
  }
}

}
</style>
